import { Pipe, PipeTransform } from '@angular/core';
import { FILE_TYPE } from '@univacity/shared/types';

@Pipe({
  name: 'fileType',
  standalone: false,
})
export class FileTypePipe implements PipeTransform {
  transform(mimetype?: string): FILE_TYPE | null {
    if (!mimetype) return null;
    const fileType = mimetype.substr(0, mimetype.indexOf('/'));
    const fileTypeEnd = mimetype.substr(mimetype.indexOf('/') + 1);
    switch (fileType) {
      case FILE_TYPE.image:
        return FILE_TYPE.image;
      case FILE_TYPE.audio:
        return FILE_TYPE.audio;
      case FILE_TYPE.video:
        return FILE_TYPE.video;
    }
    switch (fileTypeEnd) {
      case FILE_TYPE.pdf:
        return FILE_TYPE.pdf;
      default:
        if (fileTypeEnd.includes('document')) return FILE_TYPE.doc;
        return FILE_TYPE.unknown;
    }
  }
}
